import type { AxiosRequestConfig } from "axios";

import { apiClient, type ApiRequestConfig } from "./httpClient";

type PublicConfig = Pick<ApiRequestConfig, "skipAuth"> & AxiosRequestConfig;

const publicOpts: PublicConfig = { skipAuth: true };

export const cybervolunteerApi = {
  getSiteTexts: () => apiClient.get("site-texts/", publicOpts),

  getLessons: (config?: AxiosRequestConfig) =>
    apiClient.get("lessons/", config as ApiRequestConfig),

  getAnonymousLessons: () => apiClient.get("anonymous-lessons/", publicOpts),

  getLesson: (lessonId: string | number, config?: AxiosRequestConfig) =>
    apiClient.get(`lessons/${lessonId}`, config as ApiRequestConfig),

  login: (body: { username: string; password: string }) =>
    apiClient.post("login/", body, publicOpts),

  register: (body: { username: string; password: string }) =>
    apiClient.post("register/", body, publicOpts),

  createSubtask: (body: unknown) => apiClient.post("create_subtask/", body),

  checkAnswer: (body: { answers: unknown[] }) => apiClient.post("check-answer/", body),

  updateProgress: (body: { lesson_id: unknown }) => apiClient.post("update-progress/", body),

  sendSubtaskAnswers: (body: { subtask_id: unknown; answers: unknown[] }) =>
    apiClient.post("send-subtasks/", body),

  checkAdmin: () => apiClient.get("check_admin"),

  getSubtasks: () => apiClient.get("subtasks/"),

  updateSubtask: (body: { subtask_id: number; subtask_status: string }) =>
    apiClient.post("update_subtask", body),

  getCsvBlob: (taskNumber: number) =>
    apiClient.get(`get_csv/${taskNumber}`, { responseType: "blob" }),

  getAdminSubtasks: () => apiClient.get("get_admin_subtasks"),

  reorderSubtasks: (body: { ordered_ids: number[] }) => apiClient.post("reorder_subtasks", body),

  removeSubtask: (body: { subtask_id: number }) => apiClient.post("remove_subtask", body),

  saveSubtask: (body: unknown) => apiClient.post("save_subtask", body),

  getSubtask: (subtaskId: string | number) => apiClient.get(`get_subtask/${subtaskId}`),
};
